var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-form", {
    attrs: {
      layout: "inline",
      form: _vm.form
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("所属客户")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "300px"
    },
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("所属客户"),
      "show-search": "",
      "filter-option": _vm.filterOption,
      "option-filter-prop": "children"
    },
    model: {
      value: _vm.form.customerId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "customerId", $$v);
      },
      expression: "form.customerId"
    }
  }, _vm._l(_vm.customerList, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.id
      }
    }, [_c("a-tooltip", {
      attrs: {
        placement: "top",
        title: item.name
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")])], 1);
  }), 1)], 1), _c("a-form-item", [_c("a-date-picker", {
    attrs: {
      format: _vm.getFormatDate()
    },
    on: {
      change: _vm.onChange
    },
    model: {
      value: _vm.form.createAt,
      callback: function ($$v) {
        _vm.$set(_vm.form, "createAt", $$v);
      },
      expression: "form.createAt"
    }
  })], 1), _c("a-form-item", {
    attrs: {
      label: _vm.$t("权限标识")
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("权限标识"),
      allowClear: ""
    },
    model: {
      value: _vm.form.mark,
      callback: function ($$v) {
        _vm.$set(_vm.form, "mark", $$v);
      },
      expression: "form.mark"
    }
  })], 1), _c("a-form-item", {
    attrs: {
      label: _vm.$t("操作人")
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("操作人"),
      allowClear: ""
    },
    model: {
      value: _vm.form.operator,
      callback: function ($$v) {
        _vm.$set(_vm.form, "operator", $$v);
      },
      expression: "form.operator"
    }
  })], 1), _c("a-form-item", [_c("a-button", {
    attrs: {
      type: "primary",
      "html-type": "submit"
    },
    on: {
      click: _vm.getLogTable
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("查询")) + " ")])], 1)], 1), _c("a-table", {
    staticClass: "marginT20",
    attrs: {
      bordered: "",
      columns: _vm.columns,
      "data-source": _vm.data,
      align: "center",
      pagination: _vm.pagination,
      rowKey: "id"
    },
    on: {
      change: _vm.handleStandardTableChange
    }
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };